import DocumentTitle from "react-document-title";
import { generatePath, useNavigate, useParams } from "react-router";
import Error from "./Error";
import MobileHeader from "../Components/MobileHeader";
import BackButton from "../Components/MobileHeader/BackButton";
import SaveButton from "../Components/MobileHeader/SaveButton";
import WishCreateWizard, {
  useWishCreateWizard,
} from "../Components/WishCreateWizard";
import { RoutePaths } from "../routes";
import { animateScroll } from "react-scroll";
import { useEffect } from "react";
import { analyticsLogEvent } from "../../data/firebase/analytics";

export default function WishCreate() {
  const { wishlistId } = useParams();
  const [
    isLoading,
    setIsLoading,
    submitForm,
    cleanup,
    isFinalStep,
    wizardSecrets,
  ] = useWishCreateWizard();
  if (!wishlistId) {
    return <Error message="Wishlist not found" />;
  }
  const navigate = useNavigate();

  const onSubmit = () => {
    if (isFinalStep) {
      cleanup();
      analyticsLogEvent("wish_created", { wishlistId });
      navigate(generatePath(RoutePaths.specificWishlist, { wishlistId }));
    }
  };

  useEffect(() => {
    animateScroll.scrollToTop();
  });

  return (
    <DocumentTitle title={`Wish creation`}>
      <>
        <MobileHeader title="Wish creation">
          <SaveButton onClick={submitForm} loading={isLoading} />
          <BackButton />
        </MobileHeader>
        <div className="p-4">
          <WishCreateWizard
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            onSubmit={onSubmit}
            wizardSecrets={wizardSecrets}
          />
        </div>
      </>
    </DocumentTitle>
  );
}
